angular.module('inhouseNoticeEdit', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate', 'ngFileUpload']);



// WEBPACK FOOTER //
// ./src/app/boards/inhouse-notice/inhouse-notice-edit/inhouse-notice-edit.module.js